import { __assign, __extends } from "tslib";
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import radioButtonTemplate from '../template/radio-button.hbs';
import BSSInfoHintComponent from "@main/view/components/bss-infohint-component/js/bss-infohint-component";
var radioButtonTemplates = {
    defaultTemplate: radioButtonTemplate,
};
var BSSRadioButtonAdditionalServicesComponent = /** @class */ (function (_super) {
    __extends(BSSRadioButtonAdditionalServicesComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [EventManager=null] instance of _EventManager
     * @param {Formatter} [Formatter=null] instance of Formatter
     * @param {Resolution} [Resolution=null] Resolution class for width breakpoint handling
     * @param {object} [toolbox=null] provides common libraries: jquery and lodash
     */
    function BSSRadioButtonAdditionalServicesComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, radioButtonTemplates, toolbox) || this;
        _this._initInfohint();
        return _this;
    }
    /**
     * @desc actions on radio input change - prevent performing abstract _onInputChange
     * @param {Event} ev event object
     * @override
     */
    BSSRadioButtonAdditionalServicesComponent.prototype._onInputChange = function (ev) { };
    /**
     * @desc perform custom tagging
     * @param {String} throwEvent
     * @param {Boolean} [recalculation=false]
     * @param {jQuery|HTMLElement} target
     * @emits {throwEvent}
     * @private
     * @override
     */
    BSSRadioButtonAdditionalServicesComponent.prototype._throwTaggingEvent = function (throwEvent, recalculation, target) {
        var _a, _b;
        if (recalculation === void 0) { recalculation = false; }
        if (target === void 0) { target = null; }
        var productId = this._config.productId[0];
        var resultData = this._config.resultData[productId];
        var $target = this._tagTarget || null;
        if ($target === null || $target === void 0 ? void 0 : $target.length) {
            var valueChanged = $target.attr('data-valuechanged') || false;
            // trigger tagging only when radio changed its value
            if (valueChanged) {
                (_b = (_a = this._toolbox.dxpTagging) === null || _a === void 0 ? void 0 : _a[this._toolbox.currentEntity.entityId]) === null || _b === void 0 ? void 0 : _b.publish(throwEvent, __assign({}, resultData), this._config.taggingTriggerName || '');
            }
        }
    };
    BSSRadioButtonAdditionalServicesComponent.prototype._initInfohint = function () {
        if (this._config.hintText) {
            this._infohint = new BSSInfoHintComponent(this._entityTemplate, ".".concat(this._config.componentId, "_info-hint-container"), this._config, this._eventManager, this._formatter, this._resolution, this._toolbox);
        }
    };
    return BSSRadioButtonAdditionalServicesComponent;
}(BSSAbstractComponent));
export default BSSRadioButtonAdditionalServicesComponent;
